// const worker = new Worker("./messageWorkers.js")
// import { workerUrl } from "./mock"
import mqtt from "mqtt"
import type { MqttClient } from "mqtt"
const reconnectTime = 5000
type SuccessFn = (res: MessageContent | string) => void
type FailFn = (error: ErrorContent) => void
type QoS = 0 | 1 | 2
type Pub = {
  qos: QoS
  topics: {
    topic: string
    type: 1 | 2 // 1-广播， 2-自定义
  }[]
}
type Info = {
  clientid: string
  endpoint: string
  password: string
  username: string
  pub: Pub
  appId: string
}
function constructFullTopic(subTopic: string, pub: Pub) {
  const { topics } = pub
  const prefixTopic = topics.find((topic) => topic.type === 2)
  if (!prefixTopic)
    throw Error("[constructFullTopic] could found prefixTopic: " + prefixTopic)
  return `${prefixTopic.topic}/${subTopic}`
}

function extractSubTopic(fullTopic: string) {
  if (!fullTopic?.length)
    throw new Error(`[extractSubTopic] Invalid input: ${fullTopic}`)
  const topicComponents = fullTopic.split("/") || []
  return topicComponents[topicComponents.length - 1]
}
class Socket {
  client: MqttClient | null = null
  #success: Map<string, { key: string; action?: string; fn: SuccessFn }[]> =
    new Map()
  #fail: Map<string, { key: string; action?: string; fn: FailFn }[]> = new Map()
  static instance: Socket
  constructor() {
    if (!new.target) {
      throw new Error("[Socket] must be called with new")
    }
    if (Socket.instance) return Socket.instance
    Socket.instance = this
  }
  pushFail(err: ErrorContent) {
    try {
      for (const item of this.#fail.values()) {
        for (const { fn } of item) {
          fn?.(err)
        }
      }
    } catch (e) {
      console.error("pushFail error", e)
    }
  }
  connect(info: Info, topic: string) {
    try {
      const { endpoint, clientid, username, password, pub } = info
      const options = {
        clean: true,
        connectTimeout: reconnectTime,
        clientId: clientid,
        username: username,
        password: password,
        reconnect: false, // Enable automatic reconnect
      }
      const client = mqtt.connect(endpoint + "/mqtt", options)
      this.client = client

      this.client.on("connect", () => {
        console.log("mqtt connect!!!")
        const _topic = constructFullTopic(topic, pub)
        this.client?.subscribe(_topic, { qos: pub.qos || 1 }, (err: any) => {
          if (!err) {
            console.log("subscribe: " + _topic)
          } else {
            this.pushFail({
              isSuccess: false,
              msg: "subscribe error: " + JSON.stringify(err),
            })
            console.error("subscribe error>>>>>", err)
          }
        })
      })

      this.client.on("message", (topic: string, message: any) => {
        const _topic = extractSubTopic(topic)
        const success = this.#success.get(_topic)
        // console.log("message>>>>>>", message?.toString(), topic)
        const { action = "", payload = "" } =
          JSON.parse(message?.toString()) || {}
        success?.length &&
          success.forEach(({ fn, action: _action }) => {
            if (_action && _action === action) {
              fn?.(payload)
            } else {
              fn?.({
                action,
                payload,
              })
            }
          })
      })

      this.client.on("offline", () => {
        this.pushFail({ isSuccess: false, msg: "message connect is offline" })
      })

      this.client.on("error", (error: { message: any }) => {
        this.pushFail({ isSuccess: false, msg: error?.message || "error" })
      })

      this.client.on("disconnect", (packet: any) => {
        this.pushFail({
          isSuccess: false,
          msg: JSON.stringify(packet) || "disconnect",
        })
      })

      this.client.on("close", () => {
        this.pushFail({
          isSuccess: false,
          msg: "message connect is close",
        })
      })
    } catch (e) {
      console.error("connect error: ", e)
      this.pushFail({
        isSuccess: false,
        msg: "connect error",
      })
    }
  }

  subscribe(config: {
    info: Info
    topic: string
    action?: string
    success: SuccessFn
    fail?: FailFn
    key: string
  }) {
    const { info, topic, success, fail, key, action = undefined } = config
    if (success) {
      const _success = this.#success.get(topic) || []
      _success.push({ key, action, fn: success })
      this.#success.set(topic, _success)
    }
    if (fail) {
      const _fail = this.#fail.get(topic) || []
      _fail.push({ key, action, fn: fail })
      this.#fail.set(topic, _fail)
    }
    if (!this.client) {
      this.connect(info, topic)
    } else {
      const { pub } = info
      const _topic = constructFullTopic(topic, pub)
      this.client.subscribe(_topic, { qos: pub.qos || 1 }, (err: any) => {
        if (!err) {
          console.log("subscribe: " + _topic)
        } else {
          console.error("subscribe error>>>>>", err)
          this.pushFail({
            isSuccess: false,
            msg: "subscribe error: " + err,
          })
        }
      })
    }
  }

  unsubscribe(key: string) {
    if (this.#success?.size) {
      for (let [k, v] of this.#success.entries()) {
        const length = v.length
        if (length) {
          v = v.filter((i) => i.key !== key)
        }
        if (!v.length) {
          this.#success.delete(k)
        }
        if (length !== v.length) {
          this.#success.set(k, v)
        }
      }
    }
    if (this.#fail?.size) {
      for (let [k, v] of this.#fail.entries()) {
        const length = v.length
        if (length) {
          v = v.filter((i) => i.key !== key)
        }
        if (!v.length) {
          this.#fail.delete(k)
        }
        if (length !== v.length) {
          this.#fail.set(k, v)
        }
      }
    }
  }
}

export default Socket
